import { useState } from "react";
import { fileUrl } from "@/lib/api";
import { Camera, X, ChevronLeft, ChevronRight } from "lucide-react";

export const PalletPhotoGallery = ({ product }) => {
  const images = product.images || [];
  const [lightbox, setLightbox] = useState(null);
  if (images.length < 2) return null;

  return (
    <section className="mt-12 border-t-4 border-[#FFC220] pt-8" data-testid="pallet-photo-gallery">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="w-10 h-10 bg-[#0A1C40] flex items-center justify-center">
          <Camera className="w-5 h-5 text-[#FFC220]" />
        </div>
        <div>
          <h2 className="font-display font-black text-2xl tracking-tighter text-[#0A1C40]">
            Real photos of this exact pallet
          </h2>
          <p className="text-xs text-gray-500">
            {images.length} photos · what you see stacked is what you get
          </p>
        </div>
      </div>

      <div
        className="mt-5 flex gap-3 overflow-x-auto snap-x snap-mandatory pb-2 [-webkit-overflow-scrolling:touch]"
        data-testid="pallet-gallery-strip"
      >
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => setLightbox(i)}
            className="snap-start shrink-0 w-[260px] sm:w-[320px] aspect-square border-2 border-gray-200 hover:border-[#0A1C40] bg-[#F4F4F5] overflow-hidden transition-colors"
            data-testid={`pallet-gallery-photo-${i}`}
          >
            <img src={fileUrl(img)} alt={`${product.name} photo ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>

      <p className="mt-3 text-xs font-bold text-amber-800 bg-amber-50 border border-amber-300 px-3 py-2 inline-block" data-testid="pallet-gallery-disclaimer">
        No manifest on this pallet — these photos show exactly what's stacked. Sold AS-IS · FINAL SALE.
      </p>

      {lightbox !== null && (
        <div
          className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
          data-testid="pallet-gallery-lightbox"
        >
          <button className="absolute top-4 right-4 text-white p-2" data-testid="pallet-gallery-close">
            <X className="w-7 h-7" />
          </button>
          {images.length > 1 && (
            <>
              <button
                onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + images.length) % images.length); }}
                className="absolute left-2 sm:left-6 text-white bg-white/10 rounded-full p-2"
                data-testid="pallet-gallery-prev"
              >
                <ChevronLeft className="w-7 h-7" />
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % images.length); }}
                className="absolute right-2 sm:right-6 text-white bg-white/10 rounded-full p-2"
                data-testid="pallet-gallery-next"
              >
                <ChevronRight className="w-7 h-7" />
              </button>
            </>
          )}
          <img
            src={fileUrl(images[lightbox])}
            alt=""
            className="max-h-[85vh] max-w-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <div className="absolute bottom-5 text-white text-sm font-bold">{lightbox + 1} / {images.length}</div>
        </div>
      )}
    </section>
  );
};
